import { Component } from '@angular/core';

@Component({
  selector: 'app-analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.css'],
})
export class AnalysisComponent {
  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Merchant',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Banks',
      route: '/numbers/finance/plaid',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'Analysis',
      route: '/numbers/finance/analysis',
    },
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];
}
